// Vue
import {Component, Prop, Vue, Provide} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Select} from './../select/Select'
import {SelectOption} from './../select/option/SelectOption'
import {HttpService} from "../../../services/HttpService";

interface AutocompleteEntry {
    id: string,
    name: string
}

@Component({
    name: 'Autocomplete',
    components: {Select, SelectOption},
    mixins: [
        template,
    ]
})
export class Autocomplete extends Vue {

    private readonly http: HttpService = HttpService.instance

    private isLoading: boolean = false;

    @Prop()
    public url!: string

    @Prop([Array, String, Number, Boolean])
    public value: any

    @Prop()
    @Provide('selectTheme')
    public theme!: string

    @Prop()
    public disabled?: boolean

    @Prop([String, Number])
    public label?: any

    @Prop()
    public placeholder?: string

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop()
    public name!: string

    @Prop()
    public title!: string

    @Prop()
    public img!: string

    @Prop({default: true})
    public showErrors!: boolean

    @Prop({default: "0"})
    public tabindex!: string

    private loadedEntries: AutocompleteEntry[] = [];

    private emptyResult: boolean = false;

    public async loadData(searchTerm) {
        this.emptyResult = false;
        if (searchTerm && searchTerm.length > 0) {
            this.isLoading = true
            let response = await this.http.get<AutocompleteEntry[]>(this.url, {
                params: {
                    q: searchTerm
                }
            });
            this.isLoading = false

            this.loadedEntries = response.body!
            if (this.loadedEntries.length == 0) {
                this.emptyResult = true
            }
        } else {
            this.loadedEntries = [];
        }
    }

    public onSearch(searchTerm) {
        this.loadData(searchTerm);
    }

    public onInput(value) {
        let object = this.loadedEntries.find((x) => x.id == value)
        this.loadedEntries = [];
        this.emptyResult = false;

        this.$emit('input', value);
        this.$emit('inputObject', object)
    }

    public get finalPlaceholder() {
        return this.value === '' ? '' : this.placeholder;
    }
}